<script>
import { mapState } from "vuex";
export default {
  props: { ativar: Boolean },
  data () {
    return {
    }
  },
  computed: { 
    ...mapState({
      alerta: state => state.moduleAlerta.alerta,
    }),
    
  },
  methods: {
    mudadoDataFinal () {
      this.alerta.optionsDataInicial.maxDate = this.alerta.dataFinal
    },
  }    
}
</script>

<template>
  <div>
    <b-form-text>Final:</b-form-text>
    <b-form-datepicker class="mb-2 shadow rounded" placeholder="Data Final" v-model="alerta.dataFinal" :date-format-options="alerta.optionsDataFinal" @context="mudadoDataFinal"
                       :min="alerta.dataInicial" :disabled='ativar'/>
  </div>
</template>

<style>

</style>